<template>
  <span>{{ formattedValue }}</span>
</template>
<script>
  import { Money } from '@/plugin/mixin/money'

  export default {
    name: 'money',
    props: {
      value: {
        type    : Number,
        default : 0
      },
      currencyCode: {
        type    : String,
        default : 'USD'
      },
      currencySign: {
        type    : String,
        default : '$'
      },
      showCurrency: {
        type    : Boolean,
        default : true
      },
      legacyType: {
        type    : Boolean,
        default : true
      },
      decimals: {
        type: Number,
        default: 2
      }
    },
    computed: {
      activeValue() {
        return this.focused && !this.readonly ? this.legacyValue : this.formattedValue
      },
      formattedValue() {
        return Money.formatToMoney(this.legacyValue, {
          'showCurrency': this.showCurrency,
          'currencySign': this.currencySign,
          'decimals': this.decimals,
        })
      },
      legacyValue() {
        return this.legacyType ? this.value : Money.moneyToLegacyType(this.value, Math.pow(10, this.decimals))
      }
    }
  }
</script>
